import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/router";
import * as i3 from "../../shared/services/user.service";
import * as i4 from "../../shared/services/toast-custom.service";
export class RolesGuard {
    constructor(location, router, userService, ts) {
        this.location = location;
        this.router = router;
        this.userService = userService;
        this.ts = ts;
        this.user = this.userService.userInfo;
    }
    canActivate(route) {
        switch (route.data.action) {
            case 'redirect':
                const view = route.data.rules.filter(config => config.role == this.user.role.name);
                //console.log("view : "+view[0].pathModule +" view ro "+view[0].view +);
                if (view.length > 0) {
                    if (view[0].pathModule.indexOf('dashboard') != -1 &&
                        window.location.pathname.indexOf('dashboard/') != -1) {
                        const url = window.location.pathname.split('/');
                        this.router.navigate([
                            '/main/' + view[0].pathModule + '/' + url[url.length - 1]
                        ]);
                    }
                    else {
                        this.router.navigate([
                            '/main/' + view[0].pathModule + '/' + view[0].view
                        ]);
                    }
                }
                else {
                    this.location.back();
                }
                break;
            default:
                const roles = route.data.roles;
                // Validate access to modules without permission config
                if (roles && roles.length > 0) {
                    return roles.filter(rol => rol == this.user.role.name).length > 0
                        ? true
                        : false;
                }
                else {
                    // Validate access to modules with permission config
                    const permissionModules = this.userService.userModulesInfo;
                    const translateRoute = {
                        'order-management': 'orders',
                        companies: 'shippers'
                    };
                    const path = route.url && route.url[0].path;
                    const moduleValidation = path && translateRoute[path] ? translateRoute[path] : path;
                    if (permissionModules &&
                        permissionModules[moduleValidation] &&
                        Object.keys(permissionModules[moduleValidation])) {
                        if (!permissionModules[moduleValidation].active) {
                            this.displayErrorMessage();
                            setTimeout(() => {
                                this.location.back();
                            }, 500);
                        }
                        return permissionModules[moduleValidation].active;
                    }
                }
                return true;
                break;
        }
    }
    displayErrorMessage() {
        this.ts.show('error', 'You do not have access', 'Request access to this resource from an administrator');
    }
}
RolesGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RolesGuard_Factory() { return new RolesGuard(i0.ɵɵinject(i1.Location), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.UserService), i0.ɵɵinject(i4.ToastCustomService)); }, token: RolesGuard, providedIn: "root" });
